/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { UnpaidOrderViewModel } from "../models/unpaid-order-view-model";
@Injectable({
  providedIn: "root",
})
class UnpaidOrdersService extends __BaseService {
  static readonly unpaidOrdersGetUnpaidOrdersPath =
    "/api/admin/subscription/UnpaidOrders";
  static readonly unpaidOrdersEditUnpaidOrderPath =
    "/api/admin/subscription/UnpaidOrders";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  unpaidOrdersGetUnpaidOrdersResponse(): __Observable<
    __StrictHttpResponse<Array<UnpaidOrderViewModel>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/UnpaidOrders`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UnpaidOrderViewModel>>;
      })
    );
  }
  unpaidOrdersGetUnpaidOrders(): __Observable<Array<UnpaidOrderViewModel>> {
    return this.unpaidOrdersGetUnpaidOrdersResponse().pipe(
      __map((_r) => _r.body as Array<UnpaidOrderViewModel>)
    );
  }

  /**
   * @param model undefined
   */
  unpaidOrdersEditUnpaidOrderResponse(
    model: UnpaidOrderViewModel
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/subscription/UnpaidOrders`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param model undefined
   */
  unpaidOrdersEditUnpaidOrder(model: UnpaidOrderViewModel): __Observable<Blob> {
    return this.unpaidOrdersEditUnpaidOrderResponse(model).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module UnpaidOrdersService {}

export { UnpaidOrdersService };
